import { render } from "./ActionButtons.vue?vue&type=template&id=5e23cf47&scoped=true&ts=true"
import script from "./ActionButtons.vue?vue&type=script&lang=ts"
export * from "./ActionButtons.vue?vue&type=script&lang=ts"

import "./ActionButtons.vue?vue&type=style&index=0&id=5e23cf47&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e23cf47"]])

export default __exports__